import { ApiHelper } from '../apiHelper';
import { IPagination, IQuery } from '../../models/athena';
import { Observable } from 'rxjs';
import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { HttpHeaders } from '@angular/common/http';
import { LookerDashboardMetadata } from '../../models/lookerDashboardMetadata';

export class LookerDashboardMetadataDAO extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.LOOKER_DASHBOARD_METADATA, apiHelper);
  }

  findByClientRoute(clientRoute: string): Observable<any> {

    let url = this.apiHelper.getServiceName() + this.getResource() + '/findByClientRoute/' + clientRoute;
    let headers = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall(
      url,
      'GET',
      null,
      null,
      headers
    );
  }

  getDetectionReports(): Observable<LookerDashboardMetadata[]> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/detectionReports/findAll';
    let headers = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall(
      url,
      'GET',
      null,
      null,
      headers
    );
  }
}


